import React, {useEffect, useMemo, useState} from "../../__snowpack__/pkg/react.js";
import {Input, Select} from "../../__snowpack__/pkg/antd.js";
const {Option} = Select;
export const TextQuantitative = (props) => {
  const updateHandler = (value2, unit2) => {
    props.onChange && props.onChange({value: value2, unit: unit2});
    setValue(value2);
    setUnit(unit2);
  };
  const [value, setValue] = useState();
  const [unit, setUnit] = useState();
  useEffect(() => {
    setValue(props.value?.value);
    setUnit(props.value?.unit || props.options?.find((_) => _)?.value);
  }, [props.value, props.options]);
  return /* @__PURE__ */ React.createElement(Input, {
    ...props,
    onBlur: () => {
      updateHandler((value || "").trim(), unit);
    },
    addonAfter: /* @__PURE__ */ React.createElement(Select, {
      style: {width: props.optionWidth},
      value: unit,
      onChange: (val) => {
        updateHandler((value || "").trim(), val);
      },
      disabled: props.optionDisabled
    }, props.options?.map((_) => {
      return /* @__PURE__ */ React.createElement(Option, {
        key: _.value,
        value: _.value
      }, _.label);
    })),
    value,
    onChange: (event) => {
      updateHandler(event.target.value, unit);
    }
  });
};
export const TextQuantitativeAdapter = (props) => {
  const values = useMemo(() => {
    let value = props.value;
    if (!value) {
      return;
    }
    props.options?.forEach((option) => {
      value = (value || "").replace(option.value, "");
    });
    const unit = props.value?.replace(value, "");
    return {
      value,
      unit
    };
  }, [props.value, props.options]);
  return /* @__PURE__ */ React.createElement(TextQuantitative, {
    ...props,
    value: values,
    onChange: (values2) => {
      if (!values2?.value) {
        props.onChange && props.onChange(void 0);
        return;
      }
      const value = `${values2?.value || ""}${values2?.unit}`;
      props.onChange && props.onChange(value);
    }
  });
};
